import { I18n } from '@app/i18n/strings-keys';
import { COMMON_ACTION_BUTTONS } from '../../common';

export const ORDER_ACTION_BUTTONS = [
  COMMON_ACTION_BUTTONS.View,
  {
    ...COMMON_ACTION_BUTTONS.Edit,
    permissionCodes: ['VenuesInventory.Order.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Submit,
    permissionCodes: ['VenuesInventory.Order.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Cancel,
    name: I18n.Forms.OrderForm.CancelInventoryOrder,
    permissionCodes: ['VenuesInventory.Order.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Accept,
    permissionCodes: ['VenuesInventory.Order.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Reject,
    permissionCodes: ['VenuesInventory.Order.Manage'],
  },
  COMMON_ACTION_BUTTONS.Print,
  COMMON_ACTION_BUTTONS.Export,
];
